var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({width:'100%', height:_vm.innerHeight})},[_c('iframe',{staticStyle:{"border":"0","pointer-events":"none"},style:({width:'100%',height:_vm.innerHeight}),attrs:{"scrolling":"no","src":_vm.displayUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }